import React, { useState } from 'react'
import { Segmented, Drawer, Button, Spin, Empty, Badge } from 'antd'
import { FilterOutlined, UnorderedListOutlined, EnvironmentOutlined } from '@ant-design/icons'
import { AlarmFilters } from './components/AlarmFilters'
import { AlarmCard } from './components/AlarmCard'
import { AlarmMap } from './components/AlarmMap'
import { alertKey } from './components/alertKey'
import { DateFilter } from '../common/DateFilter'
import './styles/alarm_history_mobile.scss'
import './styles/alarm_filters.scss'

// Mobile Alarm History. Pure presentation — all state + handlers live in index.jsx
// (same pattern as the Phase-2 dashboard). The DetectionModal / VideoModal are rendered
// by index.jsx for both layouts, so tapping a card just calls handleDetectionClick.
export const AlarmHistoryMobile = ({
  alerts, loading, INTERVALS, selectedInterval, setInterval, onCustomDates,
  units, appVersions, isSpecial, onClick, selectedKeys,
  handleDetectionClick, typeDict, levelDict, selectedKey, viewedKeys,
}) => {
  const [filtersOpen, setFiltersOpen] = useState(false)
  const [view, setView] = useState('list')

  return (
    <div className="rz-alarms-mobile">
      <div className="rz-alarms-bar">
        <DateFilter
          options={INTERVALS}
          value={selectedInterval}
          onChange={(v) => setInterval({ key: v })}
          onCustomRange={onCustomDates}
          rightSlot={
            <>
              <Segmented
                size="small"
                value={view}
                onChange={setView}
                options={[
                  { value: 'list', icon: <UnorderedListOutlined /> },
                  { value: 'map', icon: <EnvironmentOutlined /> },
                ]}
              />
              <Badge count={selectedKeys.length} size="small" offset={[-2, 2]}>
                <Button
                  className="rz-alarms-filterbtn"
                  icon={<FilterOutlined />}
                  onClick={() => setFiltersOpen(true)}
                />
              </Badge>
            </>
          }
        />
      </div>

      {view === 'map' ? (
        <div className="rz-alarms-mapwrap">
          {loading
            ? <div className="rz-alarms-loading"><Spin /></div>
            : <AlarmMap alerts={alerts} typeDict={typeDict} onSelect={handleDetectionClick} selectedKey={selectedKey} />}
        </div>
      ) : (
        <div className="rz-alarms-list">
          {loading
            ? <div className="rz-alarms-loading"><Spin /></div>
            : (alerts && alerts.length)
              ? alerts.map(([counter, a]) => {
                  const key = alertKey(a)
                  return (
                    <AlarmCard
                      key={`${counter}-${a.detection_date}`}
                      alert={a}
                      typeDict={typeDict}
                      levelDict={levelDict}
                      onClick={() => handleDetectionClick(a)}
                      selected={key === selectedKey}
                      viewed={viewedKeys?.has(key)}
                    />
                  )
                })
              : <Empty className="rz-alarms-empty" description="No alerts in this range" />}
        </div>
      )}

      <Drawer
        className="rz-alarms-filters"
        title="Filters"
        placement="bottom"
        height="80%"
        open={filtersOpen}
        onClose={() => setFiltersOpen(false)}
      >
        <AlarmFilters
          units={units}
          appVersions={appVersions}
          isSpecial={isSpecial}
          selectedKeys={selectedKeys}
          onClick={onClick}
        />
      </Drawer>
    </div>
  )
}

export default AlarmHistoryMobile
